
<template>
    <div>
        <sample-header></sample-header>
        <div class="input-status-container header-margin">
            <div>
    
                <h1>Check your Status</h1>
                <div class="row">
                    <div class="columns small-12 medium-6 medium-offset-3">
                        <p>Enter your order confirmation number or name below and click submit to view your order status</p>
                    </div>
                </div>
    
            </div>
            <div class="row text-center">
                <div class="columns small-12 medium-6 medium-offset-3">
                    <form v-on:submit="getStatus($event)" autocomplete="off">
                        <input class='inputstatus-input' required type="text" v-model="code">
    
                        <div class="form-group pad-before-footer">
                            <input type="submit" class="btn btn-submit inputstatus-button" value="SUBMIT">
                        </div>
    
                    </form>
                </div>
            </div>
    
        </div>
        <sample-footer></sample-footer>
    </div>
</template>
<script>
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
export default {
  components: { SampleHeader, SampleFooter },
  data() {
    return {
      code: null
    };
  },
  methods: {
    getStatus(e) {
      e.preventDefault();
      this.$router.push("/status/" + this.code);
    }
  }
};
</script>
<style>
.input-status-container {
  min-height: 350px;
  text-align: center;
  padding-top: 50px;
}

.inputstatus-button {
  width: 350px;
}

.inputstatus-input {
  line-height: 14.4px;
  width: 350px;
  font-size: 25px !important;
  font-family: "Montserrat", Helvetica, Arial, san-serif;
  height: 36px;
  letter-spacing: 0.1em;
  text-align: center;
  margin: 15px auto;
}
</style>
